import { Box, Button, Popover, Typography } from "@mui/material";
import { useState } from "react";
import { CalendarGrid } from "./CalendarGrid";

const COLORS = {
    primary: "#3056D3",
    dark: "#090E34",
    stroke: "#E0E0E0",
    white: "#FFFFFF",
    body: "#637381",
};

export function DatePicker({
    selectedDate,
    onSelectDate,
    disabled = false,
    error = false,
    helperText = "",
}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);
    const id = open ? "datepicker-popover" : undefined;

    // Deriva a data inicial de navegação a partir do valor selecionado
    const initialDate = (() => {
        if (!selectedDate) return new Date();
        const [day, month, year] = selectedDate.split("/");
        return new Date(year, month - 1, day);
    })();

    const inputStyle = {
        height: "48px",
        width: "100%",
        borderRadius: "8px",
        border: `1px solid ${!error ? COLORS.stroke : "#d32f2f"}`,
        paddingLeft: "48px",
        paddingRight: "16px",
        fontSize: "16px",
        outline: "none",
        cursor: disabled ? "default" : "pointer",
        backgroundColor: COLORS.white,
        color: disabled ? "rgba(0, 0, 0, 0.38)" : "inherit",
    };

    return (
        <Box sx={{ margin: "8px 0 4px 0" }}>
            <Box sx={{ position: "relative" }}>
                {/* Input Trigger */}
                <Box sx={{ position: "relative" }}>
                    <input
                        aria-describedby={id}
                        style={inputStyle}
                        value={selectedDate || ""}
                        readOnly
                        onClick={handleClick}
                        placeholder="Selecione uma data"
                        disabled={disabled}
                    />
                    {helperText && (
                        <Typography
                            sx={{
                                fontSize: "12px",
                                mx: "14px",
                                mt: "3px",
                                color: !error ? "inherit" : "#d32f2f",
                            }}
                        >
                            {helperText}
                        </Typography>
                    )}
                    <Box
                        sx={{
                            position: "absolute",
                            left: 14,
                            top: 12,
                            color: COLORS.body,
                        }}
                    >
                        <svg
                            width="21"
                            height="20"
                            viewBox="0 0 21 20"
                            fill="none"
                        >
                            <path
                                d="M18 3.3125H16.3125V2.625C16.3125 2.25 16 1.90625 15.5937 1.90625C15.1875 1.90625 14.875 2.21875 14.875 2.625V3.28125H6.09375V2.625C6.09375 2.25 5.78125 1.90625 5.375 1.90625C4.96875 1.90625 4.65625 2.21875 4.65625 2.625V3.28125H3C1.9375 3.28125 1.03125 4.15625 1.03125 5.25V16.125C1.03125 17.1875 1.90625 18.0938 3 18.0938H18C19.0625 18.0938 19.9687 17.2187 19.9687 16.125V5.25C19.9687 4.1875 19.0625 3.3125 18 3.3125ZM3 4.71875H4.6875V5.34375C4.6875 5.71875 5 6.0625 5.40625 6.0625C5.8125 6.0625 6.125 5.75 6.125 5.34375V4.71875H14.9687V5.34375C14.9687 5.71875 15.2812 6.0625 15.6875 6.0625C16.0937 6.0625 16.4062 5.75 16.4062 5.34375V4.71875H18C18.3125 4.71875 18.5625 4.96875 18.5625 5.28125V7.34375H2.46875V5.28125C2.46875 4.9375 2.6875 4.71875 3 4.71875ZM18 16.6562H3C2.6875 16.6562 2.4375 16.4062 2.4375 16.0937V8.71875H18.5312V16.125C18.5625 16.4375 18.3125 16.6562 18 16.6562Z"
                                fill={
                                    disabled
                                        ? "rgba(0, 0, 0, 0.38)"
                                        : "currentColor"
                                }
                            />
                        </svg>
                    </Box>
                </Box>

                {/* MUI Popover */}
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    slotProps={{
                        paper: {
                            style: {
                                marginTop: "8px",
                                padding: "20px",
                                borderRadius: "12px",
                                boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
                                width: "350px",
                            },
                        },
                    }}
                >
                    {/* Calendário compartilhado */}
                    <CalendarGrid
                        selectedDate={selectedDate}
                        onSelectDay={(formatted) => {
                            onSelectDate(formatted);
                            handleClose();
                        }}
                        initialDate={initialDate}
                    />

                    {/* Botões de Ação */}
                    <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => {
                                onSelectDate(null);
                                handleClose();
                            }}
                            sx={{
                                bgcolor: "rgb(238, 238, 238)",
                                textTransform: "none",
                                borderRadius: "32px",
                                color: "#253044",
                            }}
                        >
                            Limpar
                        </Button>
                        {/* <Button
                            fullWidth
                            variant="contained"
                            onClick={handleClose}
                            sx={{
                                bgcolor: colors.primary,
                                "&:hover": { bgcolor: "#254adb" },
                                textTransform: "none",
                                borderRadius: "32px",
                            }}
                        >
                            Confirmar
                        </Button> */}
                    </Box>
                </Popover>
            </Box>
        </Box>
    );
}
